// extracted by mini-css-extract-plugin
module.exports = {"panel":"_8bbff4c"};